import { Link, useParams, useSearchParams } from 'react-router-dom';
import { Button } from '@nyce/admin-kit/ui';
import { EmptyState, Page } from '../../components/common';
import { GUIDES, guideById, guidePath } from '../guides';
import { Markdown, fill } from '../guides/markdown';
import '../onboarding.css';

export function GuidesPage() {
  return (
    <Page
      title="Installation guides"
      description="Step-by-step guides for whoever installs on site. Opened from a wizard, they carry that wizard's values."
    >
      <div className="ob-cards">
        {GUIDES.map((g) => (
          <Link key={g.id} to={guidePath(g.id)} className="nyk-card ob-card" data-guide={g.id}>
            <span className="nyk-ui-eyebrow">{g.audience}</span>
            <h3>{g.title}</h3>
          </Link>
        ))}
      </div>
    </Page>
  );
}

/** One guide, `{{key}}` filled from the query; printable (sidebar hidden in print). */
export function GuidePage() {
  const { id = '' } = useParams();
  const [params] = useSearchParams();
  const guide = guideById(id);
  if (!guide) return <EmptyState card title="No such guide." />;
  const values = Object.fromEntries(params.entries());
  return (
    <Page
      title={guide.title}
      description={guide.audience}
      actions={
        <span className="ob-noprint nyk-row-actions">
          <Link to="/onboarding/guides" className="nyk-link">
            All guides
          </Link>
          <Button variant="ghost" onClick={() => window.print()}>
            Print
          </Button>
        </span>
      }
    >
      <article className="nyk-card ob-guide" data-testid="guide">
        <Markdown text={fill(guide.text, values).replace(/^# .*\n/, '')} />
      </article>
    </Page>
  );
}
